module.exports = __webpack_public_path__ + "img/stage_signed_in.1694bf46.svg";